.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// Narrow viewports scroll the table rather than the modal body sideways.
.scroll {
  overflow-x: auto;
}

.table {
  border-collapse: collapse;
  min-width: 520px;
  width: 100%;

  th,
  td {
    border-bottom: 1px solid var(--color-border, #e2e4e9);
    padding: 12px 10px;
    text-align: left;
  }

  th {
    color: var(--color-text-muted, #535862);
    font-size: 13px;
    font-weight: 600;
  }

  td {
    font-size: 14px;
  }

  tr:last-child td {
    border-bottom: 0;
  }
}

.action-col {
  text-align: right;
  white-space: nowrap;
}

.file {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.file-icon {
  color: var(--color-text-muted, #565b65);
  flex-shrink: 0;
}

.file-link {
  color: var(--color-text, #202328);
  overflow-wrap: anywhere;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.open {
  align-items: center;
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #d4d7dd);
  border-radius: 8px;
  color: var(--color-text, #17191d);
  display: inline-flex;
  gap: 6px;
  font-size: 13px;
  padding: 7px 12px;
  text-decoration: none;

  &:hover {
    background: var(--color-surface-hover, #f6f7f8);
  }
}
